import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterFacade } from '@rx-applications/clientsite/shared/router/data-access';
import { RxButtonModule } from '@roomex/rx-components';
import { translationProvider as Translations, TRANSLATION_SCOPE } from './assets/translation.provider';
import { TranslocoModule } from '@ngneat/transloco';
import { TemporaryApproverPageComponent } from '@rx-applications/clientsite/temporary-approver/feature-temporary-approver-page';
import { TemporaryApproverLoggerService, TemporaryApproverStore } from '@rx-applications/clientsite/temporary-approver/data-access';

@Component({
  selector: 'rx-applications-temporary-approver-shell',
  standalone: true,
  imports: [CommonModule, TranslocoModule, RxButtonModule, TemporaryApproverPageComponent],
  templateUrl: './temporary-approver-feature-shell.component.html',
  styleUrl: './temporary-approver-feature-shell.component.scss',
  providers: [Translations, TemporaryApproverStore, TemporaryApproverLoggerService],
})
export class TemporaryApproverFeatureShellComponent {
  readonly TRANSLATION_SCOPE = TRANSLATION_SCOPE;

  public routerFacade = inject(RouterFacade);
}
